module.exports = __webpack_public_path__ + "img/rope.98865e25.svg";